import React from 'react';
import { motion } from 'framer-motion';
import { Search, Beaker, HeartPulse } from 'lucide-react';
const steps = [{
  number: '01',
  icon: <Search size={32} className="text-amber-500" data-id="element-52" />,
  text: 'Identificas el malestar (dolor, inflamación, insomnio).'
}, {
  number: '02',
  icon: <Beaker size={32} className="text-amber-500" data-id="element-53" />,
  text: 'Buscas el ingrediente en tu despensa según la guía.'
}, {
  number: '03',
  icon: <HeartPulse size={32} className="text-amber-500" data-id="element-54" />,
  text: 'Aplicas el Protocolo de Activación de 10 minutos y obtienes alivio.'
}];
export function HowItWorksSection() {
  return <section className="py-12 md:py-24 px-4 bg-cream-200 relative border-y border-amber-500/20" data-id="element-55">
      <div className="max-w-5xl mx-auto" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-57">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-forest-900 mb-6" data-id="element-58">
            Cómo Funciona
          </h2>
          <p className="text-ink-800 font-lora text-lg max-w-2xl mx-auto" data-id="element-59">
            Tres pasos simples entre el dolor y el alivio.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 relative" data-id="element-60">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-amber-500/30 -translate-y-1/2 z-0" data-id="element-61"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-62">
              <div className="w-24 h-24 rounded-full bg-cream-100 border-2 border-amber-500/50 flex items-center justify-center mb-6 shadow-lg group-hover:border-amber-500 group-hover:scale-105 transition-all duration-300 relative" data-id="element-63">
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-forest-900 text-cream-100 flex items-center justify-center font-playfair font-bold text-sm shadow-md" data-id="element-64">
                  {step.number}
                </div>
                {step.icon}
              </div>
              <p className="font-lora text-ink-900 text-lg leading-relaxed px-4" data-id="element-65">
                {step.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}